import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { MaintenanceService } from 'src/app/feature/maintenance/services/maintenance.service';

export const maintenanceGuard: CanActivateFn = (route, state) => {
  const maintenanceService = inject(MaintenanceService);
  const router = inject(Router);

  return maintenanceService.checkMaintenanceStatus().pipe(
    map((isMaintenance) => {
      const isTargetingMaintenancePage = state.url.startsWith('/maintenance');

      if (isMaintenance) {
        if (isTargetingMaintenancePage) {
          return true;
        } else {
          router.navigate(['/maintenance'], { replaceUrl: true });
          return false;
        }
      } else {
        if (isTargetingMaintenancePage) {
          router.navigate(['/login'], { replaceUrl: true });
          return false;
        } else {
          return true;
        }
      }
    }),
    catchError(() => {
      const isTargetingMaintenancePage = state.url.startsWith('/maintenance');
      if (isTargetingMaintenancePage) {
        router.navigate(['/login'], { replaceUrl: true });
        return of(false);
      }
      return of(true);
    })
  );
};
